// Bundle selector
const mainPrice=document.getElementById('mainPrice');
const mainWas=document.getElementById('mainWas');
const addCartBtn=document.getElementById('addCart');
let selectedVariantId=null;
let selectedBundlePrice=0;

function updateTotals(){
  if(!addCartBtn) return;
  if(mainPrice) mainPrice.textContent='$'+selectedBundlePrice.toFixed(2);
  addCartBtn.textContent='Add to cart — $'+selectedBundlePrice.toFixed(2);
}

function syncBundle(opt){
  const price=parseFloat(opt.dataset.price);
  const was=parseFloat(opt.dataset.was);
  selectedVariantId=opt.dataset.variantId;
  selectedBundlePrice=price;
  if(mainWas) mainWas.textContent = was > price ? '$'+was.toFixed(2) : '';
  updateTotals();
}
const bundleOpts=document.querySelectorAll('#bundleGroup .bundle-opt');
bundleOpts.forEach(opt=>{
  opt.addEventListener('click',()=>{
    bundleOpts.forEach(o=>o.setAttribute('aria-pressed','false'));
    opt.setAttribute('aria-pressed','true');
    syncBundle(opt);
  });
});
const initialBundle=document.querySelector('#bundleGroup .bundle-opt[aria-pressed="true"]');
if(initialBundle) syncBundle(initialBundle);

// Add to cart — real Shopify cart AJAX API
const toast=document.getElementById('toast');
if(addCartBtn){
addCartBtn.addEventListener('click',()=>{
  if(!selectedVariantId || addCartBtn.disabled) return;
  addCartBtn.disabled=true;
  const originalLabel=addCartBtn.textContent;
  addCartBtn.textContent='Adding…';
  const items=[{id:Number(selectedVariantId),quantity:1}];
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items})
  })
    .then(res=>res.json().then(data=>({ok:res.ok,data})))
    .then(({ok,data})=>{
      if(!ok){ throw new Error(data && data.description ? data.description : 'Could not add to cart'); }
      toast.textContent='✓ Added to cart';
      toast.classList.add('show');
      addCartBtn.textContent=originalLabel;
      addCartBtn.disabled=false;
      clearTimeout(window.__t);
      window.__t=setTimeout(()=>{ window.location.href='/cart'; },900);
    })
    .catch(err=>{
      toast.textContent='⚠ '+err.message;
      toast.classList.add('show');
      addCartBtn.textContent=originalLabel;
      addCartBtn.disabled=false;
      clearTimeout(window.__t);
      window.__t=setTimeout(()=>toast.classList.remove('show'),3200);
    });
});
}

// FAQ accordion
document.querySelectorAll('.faq-item').forEach(item=>{
  const q=item.querySelector('.faq-q');
  const a=item.querySelector('.faq-a');
  q.addEventListener('click',()=>{
    const open=item.getAttribute('data-open')==='true';
    document.querySelectorAll('.faq-item').forEach(o=>{
      o.setAttribute('data-open','false');
      o.querySelector('.faq-a').style.maxHeight=null;
    });
    if(!open){
      item.setAttribute('data-open','true');
      a.style.maxHeight=a.scrollHeight+'px';
    }
  });
});

// Cart page — quantity + remove controls (Shopify Cart AJAX API)
document.querySelectorAll('.cart-item').forEach(row=>{
  const key = row.dataset.key;
  const input = row.querySelector('.qty-input');
  const decreaseBtn = row.querySelector('[data-action="decrease"]');
  const increaseBtn = row.querySelector('[data-action="increase"]');
  const removeBtn = row.querySelector('.cart-item-remove');

  function updateQty(qty){
    row.style.opacity = '0.5';
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    }).then(()=>{ window.location.reload(); });
  }

  if(decreaseBtn) decreaseBtn.addEventListener('click',()=>{
    updateQty(Math.max(0, parseInt(input.value,10) - 1));
  });
  if(increaseBtn) increaseBtn.addEventListener('click',()=>{
    updateQty(parseInt(input.value,10) + 1);
  });
  if(input) input.addEventListener('change',()=>{
    updateQty(Math.max(0, parseInt(input.value,10) || 0));
  });
  if(removeBtn) removeBtn.addEventListener('click',()=>updateQty(0));
});

// Scroll reveal
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const revealTargets = document.querySelectorAll('[data-reveal]');
if(reduceMotion){
  revealTargets.forEach(t=>t.classList.add('in'));
} else {
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:0.15});
  revealTargets.forEach(t=>io.observe(t));
}
